"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateNewAccountModal = void 0;
//@ts-nocheck
var material_1 = require("@mui/material");
var material_react_table_1 = require("material-react-table");
var react_1 = require("react");
var icons_material_1 = require("@mui/icons-material");
var sxProp_1 = require("../../assets/styles/sxProp");
var api_1 = require("../../api/api");
var AppContext_1 = require("../../context/AppContext");
var States = function (props) {
    var _a = (0, react_1.useContext)(AppContext_1.default), instance = _a.instance, username = _a.username;
    var _b = (0, react_1.useState)(false), createModalOpen = _b[0], setCreateModalOpen = _b[1];
    var _c = (0, react_1.useState)([]), tableData = _c[0], setTableData = _c[1];
    var _d = (0, react_1.useState)({}), validationErrors = _d[0], setValidationErrors = _d[1];
    var _e = (0, react_1.useState)(), editRow = _e[0], setEditRow = _e[1];
    var handleCreateNewRow = function (values) {
        tableData.push(values);
        setTableData(__spreadArray([], tableData, true));
    };
    var handleSaveRowEdits = function (_a) {
        var exitEditingMode = _a.exitEditingMode, row = _a.row, values = _a.values;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!Object.keys(validationErrors).length) {
                    tableData[row.index] = values;
                    //send/receive api updates here, then refetch or update local table data for re-render
                    setTableData(__spreadArray([], tableData, true));
                    exitEditingMode(); //required to exit editing mode and close modal
                }
                return [2 /*return*/];
            });
        });
    };
    var handleCancelRowEdits = function () {
        setValidationErrors({});
    };
    var handleDeleteRow = (0, react_1.useCallback)(function (row) {
        if (!window.confirm("Are you sure you want to delete ".concat(row.getValue('name')))) {
            return;
        }
        //send api delete request here, then refetch or update local table data for re-render
        tableData.splice(row.index, 1);
        setTableData(__spreadArray([], tableData, true));
    }, [tableData]);
    var getCommonEditTextFieldProps = (0, react_1.useCallback)(function (cell) {
        return {
            error: !!validationErrors[cell.id],
            helperText: validationErrors[cell.id],
            onBlur: function (event) {
                var _a;
                var isValid = cell.column.id === 'phoneNumber'
                    ? validatePhoneNumber(event.target.value)
                    : cell.column.id === 'age'
                        ? validateAge(+event.target.value)
                        : validateRequired(event.target.value);
                if (!isValid) {
                    //set validation error for cell if invalid
                    setValidationErrors(__assign(__assign({}, validationErrors), (_a = {}, _a[cell.id] = "".concat(cell.column.columnDef.header, " is required"), _a)));
                }
                else {
                    //remove validation error for cell if valid
                    delete validationErrors[cell.id];
                    setValidationErrors(__assign({}, validationErrors));
                }
            },
        };
    }, [validationErrors]);
    var columns = (0, react_1.useMemo)(function () { return [
        {
            accessorKey: 'stateName', //normal accessorKey
            header: 'StateName',
            muiTableBodyCellEditTextFieldProps: function (_a) {
                var cell = _a.cell;
                return (__assign({}, getCommonEditTextFieldProps(cell)));
            }
        },
        {
            accessorKey: 'stateCode', //normal accessorKey
            header: 'StateCode',
            muiTableBodyCellEditTextFieldProps: function (_a) {
                var cell = _a.cell;
                return (__assign({}, getCommonEditTextFieldProps(cell)));
            }
        },
        {
            accessorKey: 'stateHolidays', //normal accessorKey
            header: 'StateHolidays',
            Cell: function (_a) {
                var cell = _a.cell;
                var variable = cell.getValue();
                return (react_1.default.createElement("ul", { className: 'NoDots' }, variable.map(function (el) {
                    return (react_1.default.createElement("li", { key: el }, el));
                })));
            }
        },
        // Hide Column
        //{
        //    accessorKey: 'stateId', //access nested data with dot notation
        //    header: 'StateId',
        //    enableEditing: false,
        //    muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
        //        ...getCommonEditTextFieldProps(cell),
        //    })
        //},
        {
            accessorKey: 'startTime', //normal accessorKey
            header: 'StartTime',
            muiTableBodyCellEditTextFieldProps: function (_a) {
                var cell = _a.cell;
                return (__assign({}, getCommonEditTextFieldProps(cell)));
            }
        },
        {
            accessorKey: 'endTime', //normal accessorKey
            header: 'EndTime',
            muiTableBodyCellEditTextFieldProps: function (_a) {
                var cell = _a.cell;
                return (__assign({}, getCommonEditTextFieldProps(cell)));
            }
        },
        {
            accessorKey: 'allDayRestriction',
            header: 'AllDayRestriction',
            muiTableBodyCellEditTextFieldProps: function (_a) {
                var cell = _a.cell;
                return (__assign({}, getCommonEditTextFieldProps(cell)));
            }
        },
        // {
        //     accessorKey: 'display', //normal accessorKey
        //     header: 'Display',
        //     muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
        //         ...getCommonEditTextFieldProps(cell),
        //     })
        // },
        {
            accessorKey: 'mandatoryConsent', //normal accessorKey
            header: 'MandatoryConsent',
            muiTableBodyCellEditTextFieldProps: function (_a) {
                var cell = _a.cell;
                return (__assign({}, getCommonEditTextFieldProps(cell)));
            }
        },
        {
            accessorKey: 'repeatCount', //normal accessorKey
            header: 'RepeatCount',
            muiTableBodyCellEditTextFieldProps: function (_a) {
                var cell = _a.cell;
                return (__assign({}, getCommonEditTextFieldProps(cell)));
            }
        },
        {
            accessorKey: 'restrictAll', //normal accessorKey
            header: 'RestrictAll',
            muiTableBodyCellEditTextFieldProps: function (_a) {
                var cell = _a.cell;
                return (__assign({}, getCommonEditTextFieldProps(cell)));
            }
        },
        {
            accessorKey: 'dowRestricton', //normal accessorKey
            header: 'DowRestriction',
            muiTableBodyCellEditTextFieldProps: function (_a) {
                var cell = _a.cell;
                return (__assign({}, getCommonEditTextFieldProps(cell)));
            }
        },
        {
            accessorKey: 'dowStartTime', //normal accessorKey
            header: 'DowStartTime',
            muiTableBodyCellEditTextFieldProps: function (_a) {
                var cell = _a.cell;
                return (__assign({}, getCommonEditTextFieldProps(cell)));
            }
        },
        {
            accessorKey: 'dowEndTime', //normal accessorKey
            header: 'DowEndTime',
            muiTableBodyCellEditTextFieldProps: function (_a) {
                var cell = _a.cell;
                return (__assign({}, getCommonEditTextFieldProps(cell)));
            }
        },
        {
            accessorKey: 'lastUpdateBy', //normal accessorKey
            header: 'Last Updated By',
            enableEditing: false
            //muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
            //    ...getCommonEditTextFieldProps(cell),
            //})
        },
        {
            accessorKey: 'lastUpdateDate', //normal accessorKey
            header: 'Last Updated Date',
            enableEditing: false
            //muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
            //    ...getCommonEditTextFieldProps(cell),
            //})
        },
    ]; }, [getCommonEditTextFieldProps]);
    var url = 'https://' + window.location.toString().split('/')[2];
    var holidayLinebreaks = function (arr) {
        var zerosReg = /T00:00:00/g;
        var response = arr.map(function (el, index) {
            return index !== arr.length - 1 ? el.replace(zerosReg, "") : el.replace(zerosReg, '');
        });
        return response;
    };
    var cleanData = function (fd) {
        var clean = [];
        fd.forEach(function (item) {
            var newItem = {
                allDayRestriction: item.allDayRestriction.toString() === 'false' ? 'false' : 'true',
                stateId: item.stateId,
                display: item.display === 'false' ? 'false' : 'true',
                dowEndTime: item.dowEndTime,
                dowRestricton: item.dowRestricton.map(function (el) { return el.concat(" "); }),
                dowStartTime: item.dowStartTime,
                endTime: item.endTime,
                mandatoryConsent: item.mandatoryConsent === false ? 'false' : 'true',
                repeatCount: item.repeatCount,
                restrictAll: item.restrictAll === false ? 'false' : 'true',
                startTime: item.startTime,
                stateCode: item.stateCode,
                stateHolidays: holidayLinebreaks(item.stateHolidays),
                stateName: item.stateName,
                lastUpdateBy: item.lastUpdateBy,
                lastUpdateDate: item.lastUpdateDate
            };
            clean.push(newItem);
        });
        setTableData(clean);
    };
    var fetchStateData = function () {
        fetch("".concat(url, "/api/dialrestrictions/states"))
            .then(function (response) {
            return response.json();
        })
            .then(function (data) {
            cleanData(data);
        });
    };
    (0, react_1.useEffect)(function () {
        fetchStateData();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(material_1.Typography, { variant: 'h4', sx: sxProp_1.dishFontSx }, "State Dial Restrictions")),
        react_1.default.createElement("br", null),
        react_1.default.createElement("div", null,
            react_1.default.createElement(material_react_table_1.default, { displayColumnDefOptions: {
                    'mrt-row-actions': {
                        muiTableHeadCellProps: {
                            align: 'center',
                        },
                        size: 120,
                    },
                }, columns: columns, data: tableData, enableColumnFilters: true, enableDensityToggle: false, enableFullScreenToggle: false, enableHiding: true, 
                //Top tool bar with add and search
                enableTopToolbar: true, enableColumnActions: false, enableBottomToolbar: true, enableSorting: true, initialState: {
                    sorting: [
                        {
                            id: 'stateCode',
                            desc: false
                        }
                    ],
                    pagination: {
                        pageIndex: 0,
                        pageSize: 100
                    },
                }, 
                //Action Colums
                enableEditing: true, onEditingRowSave: handleSaveRowEdits, onEditingRowCancel: handleCancelRowEdits, muiTableHeadCellProps: {
                    sx: sxProp_1.dishFontSx
                }, muiTableBodyCellProps: {
                    sx: sxProp_1.dishFontSx
                }, renderRowActions: function (_a) {
                    var row = _a.row, table = _a.table;
                    return (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', gap: '1rem' } },
                        react_1.default.createElement(material_1.Tooltip, { arrow: true, placement: "left", title: "Edit" },
                            react_1.default.createElement(material_1.IconButton, { onClick: function () {
                                    setEditRow(tableData[row.index]);
                                    setCreateModalOpen(true);
                                } },
                                react_1.default.createElement(icons_material_1.Edit, null)))));
                } }),
            react_1.default.createElement(exports.CreateNewAccountModal, { columns: columns, open: createModalOpen, onClose: function () {
                    setCreateModalOpen(false);
                    fetchStateData();
                }, onSubmit: handleCreateNewRow, item: editRow }))));
};
//example of creating a mui dialog modal for creating new rows
var CreateNewAccountModal = function (_a) {
    var open = _a.open, columns = _a.columns, onClose = _a.onClose, onSubmit = _a.onSubmit, item = _a.item;
    var _b = (0, react_1.useState)(function () {
        return columns.reduce(function (acc, column) {
            var _a;
            if (column.accessorKey === "stateId")
                acc[column.accessorKey] = new Date().toLocaleString();
            else
                acc[(_a = column.accessorKey) !== null && _a !== void 0 ? _a : ''] = '';
            return acc;
        }, {});
    }), values = _b[0], setValues = _b[1];
    var _c = (0, react_1.useState)([]), days = _c[0], setDays = _c[1];
    var _d = (0, react_1.useState)([]), currentHolidays = _d[0], setCurrentHolidays = _d[1];
    var _e = (0, react_1.useState)([]), updateHolidays = _e[0], setUpdateHolidays = _e[1];
    var _f = (0, react_1.useState)(""), newHoliday = _f[0], setNewHoliday = _f[1];
    var _g = (0, react_1.useState)(null), newStart = _g[0], setNewStart = _g[1];
    var _h = (0, react_1.useState)(null), newEnd = _h[0], setNewEnd = _h[1];
    var _j = (0, react_1.useState)({
        endBeforeStart: 0,
        missingTimeStamp: 0
    }), validationErrors = _j[0], setValidationErrors = _j[1];
    var username = (0, react_1.useContext)(AppContext_1.default).username;
    (0, react_1.useEffect)(function () {
        if (item === null || item === void 0 ? void 0 : item.dowRestricton) {
            // console.log(item)
            var darray = item.dowRestricton.map(function (el) { return el.trim(); });
            setDays(darray);
        }
        if (item === null || item === void 0 ? void 0 : item.stateHolidays) {
            var ditchTheSpace = item.stateHolidays.map(function (el) {
                return el.substring(0, 10);
            });
            var changeItBack = item.stateHolidays.map(function (el) {
                var newLineReg = /,\n/g;
                return el.replace(newLineReg, 'T00:00:00');
            });
            setCurrentHolidays(ditchTheSpace);
            setUpdateHolidays(changeItBack);
        }
        if (item === null || item === void 0 ? void 0 : item.startTime) {
            setNewStart(item.startTime);
        }
        if (item === null || item === void 0 ? void 0 : item.endTime) {
            setNewEnd(item.endTime);
        }
    }, [item]);
    var dayStrings = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var handleCancel = function () {
        setValues(function () {
            return columns.reduce(function (acc, column) {
                var _a;
                if (column.accessorKey === "allDayRestriction")
                    acc[column.accessorKey] = new Date().toLocaleString();
                else
                    acc[(_a = column.accessorKey) !== null && _a !== void 0 ? _a : ''] = '';
                return acc;
            }, {});
        });
        onClose();
    };
    var validator = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newObj, validation, changeItBack, user, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newObj = item;
                    validation = {
                        endBeforeStart: 0,
                        missingTimeStamp: 0
                    };
                    if (newObj.startTime !== newStart && newStart !== null) {
                        newObj.startTime = newStart;
                    }
                    if (newObj.endTime !== newEnd && newEnd !== null) {
                        newObj.endTime = newEnd;
                    }
                    if ((newObj.endTime <= newObj.startTime) && (newObj.startTime !== null) && (newObj.endTime !== null)) {
                        // console.log(newObj.startTime)
                        // console.log(newObj.endTime)
                        validation.endBeforeStart = 1;
                    }
                    // console.log(newObj.startTime)
                    // console.log(newObj.endTime)
                    if ((newObj.startTime === null || newObj.startTime === "") && (newObj.endTime !== null && newObj.endTime !== "")) {
                        // console.log("ERROR1")
                        validation.missingTimeStamp = 1;
                    }
                    else if ((newObj.startTime !== null && newObj.startTime !== "") && (newObj.endTime === null || newObj.endTime === "")) {
                        // console.log("ERROR2")
                        validation.missingTimeStamp = 1;
                    }
                    changeItBack = currentHolidays.map(function (el) {
                        return el.concat('T00:00:00');
                    });
                    newObj.stateHolidays = changeItBack;
                    newObj.dowRestricton = days;
                    user = "";
                    username === "" ? user = "SYSTEM" : user = username.substring(5);
                    newObj.lastUpdateBy = user;
                    // console.log(newObj);
                    setValidationErrors(validation);
                    if (!(validation.endBeforeStart === 1 || validation.missingTimeStamp === 1)) return [3 /*break*/, 1];
                    return [2 /*return*/, null];
                case 1:
                    // console.log(validation)
                    console.log("PUTTING");
                    return [4 /*yield*/, (0, api_1.putStateUpdate)(newObj)];
                case 2:
                    response = _a.sent();
                    setNewStart(null);
                    setNewEnd(null);
                    setValidationErrors({
                        endBeforeStart: 0,
                        missingTimeStamps: 0
                    });
                    onClose();
                    return [2 /*return*/, response];
            }
        });
    }); };
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, validator()];
                case 1:
                    response = _a.sent();
                    setValues(function () {
                        return columns.reduce(function (acc, column) {
                            var _a;
                            if (column.accessorKey === "display")
                                acc[column.accessorKey] = new Date().toLocaleString();
                            else
                                acc[(_a = column.accessorKey) !== null && _a !== void 0 ? _a : ''] = '';
                            return acc;
                        }, {});
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDatePicker = function (e) {
        if (e.target && e.target.value) {
            setNewHoliday(e.target.value);
        }
    };
    var handleStartPicker = function (e) {
        if (e.target && e.target.value) {
            var split = e.target.value.split(":");
            if (split[1] !== "00")
                split[1] = "00";
            var joined = split.join(":");
            setNewStart(joined);
        }
    };
    var handleEndPicker = function (e) {
        if (e.target && e.target.value) {
            var split = e.target.value.split(":");
            if (split[1] !== "00")
                split[1] = "00";
            var joined = split.join(":");
            setNewEnd(joined);
        }
    };
    var toggleDay = function (e) {
        var value = e.target.value;
        setDays(typeof value === 'string' ? value.split(',') : value);
    };
    (0, react_1.useEffect)(function () {
        console.log(validationErrors);
    }, [validationErrors]);
    return (react_1.default.createElement(material_1.Dialog, { open: open },
        react_1.default.createElement(material_1.DialogTitle, { textAlign: "center" }, "Edit State Dial Restriction"),
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                react_1.default.createElement(material_1.Stack, { sx: {
                        width: '100%',
                        minWidth: { xs: '300px', sm: '360px', md: '400px' },
                        gap: '1.5rem',
                    } }, columns.map(function (column) {
                    // if (item && column.accessorKey) console.log(item[column.accessorKey])
                    if (column.accessorKey === "stateHolidays") {
                        return (react_1.default.createElement(react_1.default.Fragment, null,
                            column.header,
                            react_1.default.createElement(material_1.Grid, { container: true }, (currentHolidays && Array.isArray(currentHolidays) && currentHolidays.length > 0) &&
                                currentHolidays.map(function (el, index) {
                                    return (react_1.default.createElement(material_1.Grid, { id: index, key: index, item: true, xs: 4 },
                                        react_1.default.createElement(material_1.IconButton, { "aria-label": 'delete', size: "small", onClick: function () { return setCurrentHolidays(function () {
                                                var newArr = __spreadArray([], currentHolidays, true);
                                                // console.log(newArr[index])
                                                if (index === 0)
                                                    newArr.shift();
                                                else
                                                    newArr.splice(index, 1);
                                                return newArr;
                                            }); } },
                                            react_1.default.createElement(icons_material_1.Delete, { fontSize: 'inherit' })),
                                        el.substring(0, 10),
                                        react_1.default.createElement("br", null)));
                                })),
                            react_1.default.createElement("input", { type: 'date', className: 'DatePicker', onChange: handleDatePicker }),
                            react_1.default.createElement(material_1.Button, { sx: __assign(__assign({}, sxProp_1.buttonPrimary), { width: "10rem" }), onClick: (function () {
                                    var dateReg = /^\d{4}-\d{2}-\d{2}$/;
                                    if (dateReg.test(newHoliday) && currentHolidays.indexOf(newHoliday) === -1) {
                                        setCurrentHolidays(__spreadArray(__spreadArray([], currentHolidays, true), [newHoliday], false));
                                        setNewHoliday("");
                                    }
                                }) }, "Add Holiday")));
                    }
                    else if (column.accessorKey === "startTime") {
                        return (react_1.default.createElement(react_1.default.Fragment, null,
                            column.header,
                            react_1.default.createElement("input", { step: "3600", type: "time", id: "startTime", name: "startTime", value: newStart, onChange: handleStartPicker })));
                    }
                    else if (column.accessorKey === "endTime") {
                        return (react_1.default.createElement(react_1.default.Fragment, null,
                            column.header,
                            react_1.default.createElement("input", { step: "3600", type: "time", id: "endTime", name: "endTime", value: newEnd, onChange: handleEndPicker }),
                            validationErrors.endBeforeStart === 1 &&
                                react_1.default.createElement(material_1.Typography, { sx: sxProp_1.errorText }, "Start Time must be before End Time"),
                            validationErrors.missingTimeStamp === 1 &&
                                react_1.default.createElement(material_1.Typography, { sx: sxProp_1.errorText }, "Missing or Incomplete Timestamp")));
                    }
                    else if (column.accessorKey === "dowRestricton") {
                        return (react_1.default.createElement(react_1.default.Fragment, null,
                            column.header,
                            react_1.default.createElement(material_1.Select, { multiple: true, value: days, renderValue: function (selected) { return selected.join(', '); }, onChange: toggleDay }, dayStrings.map(function (el) {
                                return (react_1.default.createElement(material_1.MenuItem, { key: el, value: el },
                                    react_1.default.createElement(material_1.Checkbox, { checked: days.indexOf(el) > -1 }),
                                    react_1.default.createElement(material_1.ListItemText, { primary: el })));
                            }))));
                    }
                    else {
                        return (react_1.default.createElement(react_1.default.Fragment, null,
                            column.header,
                            react_1.default.createElement(material_1.TextField, { key: column.accessorKey, name: column.accessorKey, value: (item && column.accessorKey ? item[column.accessorKey] : ""), disabled: true, onChange: function (e) {
                                    var _a;
                                    return setValues(__assign(__assign({}, values), (_a = {}, _a[e.target.name] = e.target.value, _a)));
                                } })));
                    }
                })))),
        react_1.default.createElement(material_1.DialogActions, { sx: { p: '1.25rem' } },
            react_1.default.createElement(material_1.Button, { sx: sxProp_1.buttonSecondary, onClick: handleCancel }, "Cancel"),
            react_1.default.createElement(material_1.Button, { sx: sxProp_1.buttonPrimary, onClick: handleSubmit, variant: "contained" }, "Submit"))));
};
exports.CreateNewAccountModal = CreateNewAccountModal;
var validateRequired = function (value) { return !!value.length; };
var validatePhoneNumber = function (number) { return !!number.length; };
//&&
// email
//   .toLowerCase()
//   .match(
//     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
// );
var validateAge = function (age) { return age >= 18 && age <= 50; };
exports.default = States;
